import { DateTime } from 'luxon';

export const profileDrv = {
    namespaced: true,

    state: {
        date: {
            startDate: null,
            endDate: null
        },
        tab: 'training'
    },

    getters: {
        // Fall back to the global report filter dates when no DRV-specific date is set yet.
        // The DRV date is only seeded once the filter component mounts, but consumers
        // (training/analysis/physiology reports) can fire requests before that happens,
        // which would otherwise send empty start/end dates and get rejected by the API.
        getStartDate(state, getters, rootState, rootGetters) {
            const startDate = state.date.startDate || rootGetters['reportsGlobal/filter'].startDate;
            return DateTime.fromISO(startDate).toISODate();
        },

        getEndDate(state, getters, rootState, rootGetters) {
            const endDate = state.date.endDate || rootGetters['reportsGlobal/filter'].endDate;
            return DateTime.fromISO(endDate).toISODate();
        },

        getTab(state) {
            return state.tab;
        }
    },

    mutations: {
        setStartDate(state, date) {
            state.date.startDate = date;
        },

        setEndDate(state, date) {
            state.date.endDate = date;
        },

        setTab(state, payload) {
            state.tab = payload;
        },

        resetState(state) {
            state.date.startDate = null;
            state.date.endDate = null;
        }
    }
};

export default profileDrv;
